<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Offers"
                        sub-title="Editing a offer"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                     <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>

                    <app-button
                        v-if="offer"
                        element="a"
                        class="btn  btn--secondary  btn--secondary--sml ml-4"
                        @click="$router.push({ name: 'offers.home', query: { page: $route.params.page ? $route.params.page : 1, search: $route.params.search ? $route.params.search : '' } })"
                    >
                        Cancel
                    </app-button>
                </div>
            </div>

            <app-tabs-wrapper default="general" :loading="loading" :initial="loading" class="mb-8">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger name="general" :handle-click="toggle" :active="active">General</app-tabs-trigger>
                    <app-tabs-trigger name="content" :handle-click="toggle" :active="active">Content</app-tabs-trigger>
                    <app-tabs-trigger name="locations" :handle-click="toggle" :active="active">Locations</app-tabs-trigger>
                    <app-tabs-trigger name="seo" :handle-click="toggle" :active="active">SEO &amp; Search</app-tabs-trigger>
                </div>

                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content name="general" :active="active">
                        <app-field-select
                            :required="true"
                            label="Locale"
                            :items="items.locales"
                            v-model="fields.locale_id"
                            disabled="true"
                            preselect="&mdash; Please select &mdash;"
                            :error="errors.locale_id"
                        />

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="true"
                                    label="Title"
                                    v-model="fields.title"
                                    :error="errors.title"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-text
                                    :required="true"
                                    label="Slug"
                                    description="Lowercase letters, numbers and hyphens (-) ONLY. No special letters e.g. Ö, ü, ß"
                                    v-model="fields.slug"
                                    :error="errors.slug"
                                />
                            </div>
                        </div>

                        <div>
                            <app-field-toggle
                                :required="false"
                                label="Use booking form? Leaving this disabled will display standard contact form."
                                v-model="fields.booking_form"
                                :error="errors.booking_form"
                            />
                        </div>

                        <div>
                            <app-field-toggle
                            :required="false"
                            label="Disable all forms for this offer."
                            v-model="fields.disable_forms"
                            :error="errors.disable_forms"
                            />
                        </div>

                        <div>
                            <app-field-select
                                :required="true"
                                label="Form type"
                                :items="items.form_types"
                                v-model="fields.form_type"
                                :error="errors.form_types"
                            />
                        </div>

                        <app-field-toggle
                            :required="false"
                            label="Published?"
                            v-model="fields.published"
                            :error="errors.published"
                        />

                        <app-field-datetime
                            :required="false"
                            label="Published At"
                            v-if="fields.published"
                            v-model="fields.published_at"
                            :error="errors.published_at"
                        />

                        <app-field-datetime
                            :required="false"
                            label="Expires At"
                            v-if="fields.published"
                            v-model="fields.expires_at"
                            :error="errors.expires_at"
                        />
                    </app-tabs-content>
                    <app-tabs-content name="content" :active="active">
                        <app-field-category
                            :required="true"
                            label="Category"
                            v-model="fields.category_id"
                            :error="errors.category_id"
                            :items="mappedCategories"
                        />

                        <app-field-select
                            :required="false"
                            label="Connected Service"
                            :items="items.services[fields.locale_id]"
                            v-model="fields.service_id"
                            :error="errors.service_id"
                            v-if="fields.locale_id != ''"
                        />

                        <app-field-text
                            label="Button URL"
                            v-model="fields.button_url"
                            :error="errors.button_url"
                            v-if="!fields.service_id || fields.service_id == '0'"
                        />

                        <app-field-text
                            label="Button Text"
                            v-model="fields.button_text"
                            :error="errors.button_text"
                            v-if="!fields.service_id || fields.service_id == '0'"
                        />

                        <app-field-text
                            label="Price Copy"
                            v-model="fields.from_copy"
                            :error="errors.from_copy"
                        />

                        <app-field-text
                            label="Price Copy Suffix"
                            v-model="fields.from_copy_suffix"
                            :error="errors.from_copy_suffix"
                        />

                        <div class="mb-4">
                            <app-field-currency
                                :required="true"
                                :classes="{ wrapper: { 'reset': true } }"
                                label="Default Price"
                                v-model="fields.default_price"
                                :error="errors.default_price"
                            />
                            <app-button element="a" class="btn  btn--primary  btn--primary--sml mt-2" @click="applyDefaultPriceToLocations">
                                Apply to all locations
                            </app-button>
                        </div>

                        <app-field-select
                            :required="true"
                            label="Price Type"
                            :items="items.price_types"
                            v-model="fields.price_type"
                            preselect="&mdash; Please select &mdash;"
                            :error="errors.price_type"
                        />

                        <app-field-toggle
                            :required="false"
                            label="Display price?"
                            v-model="fields.display_price"
                            :error="errors.display_price"
                        />

                        <app-field-trix
                            :required="false"
                            label="Description"
                            v-model="fields.description"
                            :error="errors.description"
                        />

                        <app-field-trix
                            :required="false"
                            label="Terms and conditions"
                            v-model="fields.terms"
                            :error="errors.terms"
                        />

                        Promo bar<br/><br/>
                        <app-field-text
                            label="Promo title"
                            v-model="fields.promo_ttl"
                            :error="errors.promo_ttl"
                        />

                        <app-field-text
                            label="Promo sub title"
                            v-model="fields.promo_subttl"
                            :error="errors.promo_subttl"
                        />

                         <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-file
                                    :required="false"
                                    label="Thumbnail"
                                    v-model="fields.thumbnail"
                                    :error="errors.thumbnail"
                                    helper="Maximum width: 750px"
                                    :types="{images: true, files: false}"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-file
                                    :required="false"
                                    label="Image"
                                    v-model="fields.image"
                                    :error="errors.image"
                                    helper="Maximum width: 750px"
                                    :types="{images: true, files: false}"
                                />
                            </div>
                        </div>
                    </app-tabs-content>
                    <app-tabs-content name="locations" :active="active">
                        <div>
                            <app-field-toggle
                                :required="false"
                                label="Display this offer on the 'Offers' page when no user location is set?"
                                v-model="fields.offers_display"
                                :error="errors.offers_display"
                            />
                        </div>

                        <app-table v-if="items.locations.length > 0">
                            <app-table-header>
                                <app-table-row :header="true">
                                    <app-table-cell :header="true">
                                        <strong>Location</strong>
                                    </app-table-cell>
                                    <app-table-cell class="text-center" :header="true">
                                        <strong>Price</strong>
                                    </app-table-cell>
                                    <app-table-cell class="text-center" :header="true">
                                        <strong>Published / Enabled</strong>
                                    </app-table-cell>
                                </app-table-row>
                            </app-table-header>

                            <app-table-body>
                                <app-table-row v-for="(l, i) in items.locations" :key="i">
                                    <app-table-cell v-html="l.name" />
                                    <app-table-cell class="text-center">
                                        <app-field-currency
                                            :required="true"
                                            v-model="fields.config[l.id].price"
                                            :error="errors.price"
                                            :classes="{ wrapper: { 'reset': true } }"
                                        />
                                    </app-table-cell>
                                    <app-table-cell class="text-center">
                                        <app-field-toggle
                                            :required="false"
                                            v-model="fields.config[l.id].published"
                                            :error="errors.published"
                                            :classes="{ wrapper: { 'reset': true } }"
                                        />
                                    </app-table-cell>
                                </app-table-row>
                            </app-table-body>
                        </app-table>
                    </app-tabs-content>
                    <app-tabs-content name="seo" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-repeatable
                                    :required="false"
                                    label="Keywords (for searching)"
                                    placeholder="Enter a keyword"
                                    v-model="fields.keywords"
                                    :error="errors.keywords"
                                />
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <app-field-repeatable
                                    :required="false"
                                    label="Phrases (for searching)"
                                    placeholder="Enter a phrase"
                                    v-model="fields.phrases"
                                    :error="errors.phrases"
                                />
                            </div>
                        </div>

                        <app-field-text
                            :required="false"
                            label="Meta Title"
                            v-model="fields.meta_title"
                            :error="errors.meta_title"
                        />

                        <app-field-textarea
                            :required="false"
                            label="Meta Description"
                            v-model="fields.meta_desc"
                            :error="errors.meta_desc"
                            rows="4"
                        />

                        <app-seo-widget :title="fields.meta_title" :description="fields.meta_desc" :slug="fields.slug" />
                    </app-tabs-content>
                </div>
            </app-tabs-wrapper>
        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import SelectField from '@/components/fields/inputs/Select';
    import TextField from '@/components/fields/inputs/Text';
    import CategoryField from '@/components/fields/inputs/Category';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextareaField from '@/components/fields/inputs/Textarea';
    import DateTimeField from '@/components/fields/inputs/DateTime';
    import TrixField from '@/components/fields/inputs/Trix';
    import CurrencyField from '@/components/fields/inputs/Currency';
    import RepeatableField from '@/components/fields/inputs/Repeatable';
    import FileField from '@/components/fields/inputs/File';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';
    import SEO from '@/components/SEO';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'offers.edit',

        data: () => ({
            offer: null,
            fields: {
                locale_id: '',
                category_id: '',
                service_id: '',
                title: '',
                slug: '',
                description: '',
                terms: '',
                from_copy: 'Now only',
                from_copy_suffix: '',
                default_price: 0.00,
                price_type: '',
                display_price: true,
                thumbnail: '',
                image: '',
                keywords: [],
                phrases: [],
                meta_title: '',
                meta_desc: '',
                disable_forms: false,
                booking_form: false,
                form_type: '',
                published: false,
                published_at: '',
                expires_at: '',
                button_url: '',
                button_text: '',
                promo_ttl: '',
                promo_subttl: '',
                offers_display: 1,
                config: {}
            },
            items: {
                locales: [],
                categories: [],
                locations: [],
                services: [],
                price_types: [
                    {
                        label: '%',
                        value: '%',
                    },
                    {
                        label: 'Money / Currency',
                        value: 'M'
                    }
                ],
                form_types: [
                    {
                        label: 'None',
                        value: null
                    },
                    {
                        label: 'Contact',
                        value: 'contact-form'
                    },
                    {
                        label: 'MOT reminder',
                        value: 'mot-reminder'
                    }
                ]
            },
            loading: false,
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-field-select': SelectField,
            'app-field-text': TextField,
            'app-field-category': CategoryField,
            'app-field-toggle': ToggleField,
            'app-field-textarea': TextareaField,
            'app-field-datetime': DateTimeField,
            'app-field-trix': TrixField,
            'app-field-currency': CurrencyField,
            'app-field-repeatable': RepeatableField,
            'app-field-file': FileField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent,
            'app-seo-widget': SEO
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            if (typeof this.$route.params.id != 'undefined') {
                this.loading = true;

                this.getCategories()
                    .then(response => {
                        return this.getLocations();
                    })
                    .then(response => {
                        this.getOffer(this.$route.params.id)
                            .then(response => {
                                this.setLocales();

                                for (let index in this.offer) {
                                    if (typeof this.fields[index] !== 'undefined') {
                                        switch (index) {
                                            case "published_at":
                                                if(this.offer[index] != null) {
                                                    this.fields[index] = this.offer[index].split(' ').join('T') + '.000Z';
                                                }
                                                break;

                                            case "expires_at":
                                                if(this.offer[index] != null) {
                                                    this.fields[index] = this.offer[index].split(' ').join('T') + '.000Z';
                                                }
                                                break;

                                            case "config":
                                                for(let key in this.offer[index]) {
                                                    if(typeof this.offer[index][key].location_id != 'undefined' && this.fields[index][this.offer[index][key].location_id] != 'undefined') {
                                                        this.fields[index][this.offer[index][key].location_id] = {
                                                            price: this.offer[index][key].price,
                                                            published: this.offer[index][key].published
                                                        };
                                                    }
                                                }
                                                break;

                                            default:
                                                this.fields[index] = this.offer[index];
                                        }
                                    }
                                }
                            })
                            .catch(error => {
                                this.$router.push({name: 'offers.home'});
                            });
                    })
                    .then(response => {
                        return this.getServices();
                    })
                    .then(response => {
                        this.loading = false;
                    });
            } else {
                this.$router.push({name: 'offers.home'});
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            }),

            mappedCategories() {
                return this.items.categories.length > 0 ? this.items.categories.map((item) => {
                    return {
                        name: item.name,
                        icon: item.svg,
                        value: item.id
                    }
                }) : [];
            }
        },

        methods: {
            checkLocale(locale_check) {
                for (let index in this.locales) {
                    if (this.locales[index].flag == locale_check && this.locales[index].default == 1) {
                        return true;
                    }
                }

                return false;
            },
            applyDefaultPriceToLocations() {
                let price = this.fields.default_price;

                for (let index in this.fields.config) {
                    this.fields.config[index].price = price;
                }

                this.$toasted.show('The default price has been added to all locations. If you didn\'t mean to do this, just refresh the page.', {
                    type: "success",
                    position: "bottom-right",
                    duration : 5000
                });
            },
            getLocations() {
                return Api.request('get', `offers/locations`)
                    .then(({ data }) => {
                        this.items.locations = data.locations;
                        for(let key in data.locations) {
                            this.fields.config[data.locations[key].id] = {
                                price: 0.00,
                                published: true
                            };
                        }
                    });
            },
            getCategories() {
                return Api.request('get', `offers/categories`)
                    .then(({ data }) => {
                        this.items.categories = data.categories;
                    });
            },
            getServices() {
                return Api.request('get', `offers/services`)
                    .then(({ data }) => {
                        this.items.services = data.services;
                    });
            },
            getOffer(id) {
                return Api.request('get', `offers/edit/${id}`)
                    .then(({ data }) => {
                        this.offer = data.offer;
                    });
            },
            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', `offers/update/${this.offer.id}`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, {
                            type: "success",
                            position: "bottom-right",
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'offers.home',
                            query: {
                                page: this.$route.params.page ? this.$route.params.page : 1,
                                search: this.$route.params.search ? this.$route.params.search : ''
                            }
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
            setLocales() {
                if (this.locales.length > 0) {
                    this.locales.forEach(locale => {
                        this.items.locales.push({
                            label: locale.lang,
                            value: locale.id
                        });
                    });
                }
            }
        },

        // watch: {
        //     'fields.title': {
        //         handler(val) {
        //             this.fields.slug = val.toString().toLowerCase()
        //                 .replace(/\s+/g, '-')           // Replace spaces with -
        //                 .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        //                 .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        //                 .replace(/^-+/, '')             // Trim - from start of text
        //                 .replace(/-+$/, '');            // Trim - from end of text
        //         }
        //     }
        // }
    }
</script>



// WEBPACK FOOTER //
// src/views/offers/Edit.vue